"use strict";

// remove the SY2024-2025 prefersSpa flag
localStorage.removeItem("prefersSpa");

$(function () {
    if (enableSinglePageApp) {
        if (sessionStorage.getItem("prefersSpa") !== "false") {
            location.href = '../spa';
        }

        $(".changeSite").on("click", () => {
            sessionStorage.setItem("prefersSpa", "true");
        });
    }

    $(".input-validation-error")
        .next(".field-validation-error")
        .addClass("glyphicon glyphicon-remove form-control-feedback")
        .attr("title", function() {
            return $(this).html();
        })
        .empty()
        .closest(".form-group")
        .addClass("has-error has-feedback");
});
